module.exports = __webpack_public_path__ + "static/media/v6.f742f367.mp4";